export const URLS = {
    BASE_URL: 'https://www.hisense-usa.com',
    SITE_URL: 'https://www.wix-hisense-staging.com',
    SUPPORT: 'support',
    AUTHORIZED_RETAILERS: 'authorized-retailers',
    GET_MODEL: 'https://api.hsp.hisenseportal.com/api/v1/public/model',
}

export const PATHS = {
    EXTENDED_WARRANTY_PRODUCT_PAGE: '/extended-service-plan-wizard',
    EXTENDED_WARRANTY_CATEGORY_PAGE: '/extended-service-plan-model-selection',
    EXTENDED_WARRANTY_HOME_PAGE: '/extended-service-plan',
}

export const PAGES = {
    EXTENDED_WARRANTY_HOME_PAGE: "Extended Warenty Router",
    EXTENDED_WARRANTY_PRODUCT_PAGE: "Extended Warrenty Product Router",
    EXTENDED_WARRANTY_CATEGORY_PAGE: "Extended Warrenty Category Router",
    SUPPORT_SEARCH_PAGE: 'Support Search Page',
    REGISTER_PRODUCT: 'Register Product',
    FIRMWARE_DOWNLOAD: 'Firmware Download',
    FAQ: 'FAQ',
    FAQ_TELEVISIONS: "FAQ - Televisions",
    FAQ_TELEVESIONS_COMMON_QUESTIONS:'FAQ - Televisions - Common Questions',
    FAQ_R7E_SERIES_FAQ: 'FAQ - R7E Series FAQ',
    FAQ_PORTABLE_ACS: 'FAQ - Portable ACs',
    FAQ_LASER_TV: 'FAQ - Laser TV',
    FAQ_DEHUMIDIFIERS: 'FAQ - Dehumidifiers', 
    PRODUCT_SUPPORT: "Product Support",  
}

export const LIGHTBOXES = {
    ADD_TO_COMPARE: "add-to-compare",  
}

export const EXTENDED_WARRANTY_STATES = {
    FORM: 'form',
    PLANS: 'plans',
    PRICE: 'price',
}

export const ERROR_MESSAGES = {
    INVALID_PRICE: "invalid Price",
}

export const MAIN_CATEGORIES = [
    {
        name: "Televisions",
        id: "53e5d45a-bd9d-3f89-ccee-9e8bac5abac3",
        mainMedia: 'https://static.wixstatic.com/media/1d7134_379b25416f2d4fd3a81fc865e777238f~mv2.webp'
    },
    {
        name: "Projectors",
        id: "a779ad07-51c8-d6b1-c24a-b2295edce8ba",
        mainMedia: 'https://static.wixstatic.com/media/9be79e_66b06f00182646839c8b72e953d3958d~mv2.webp'
    },
    {
        name: "Audio",
        id: "14395010-fc88-4bc8-825c-2dbb53b701a9",
        mainMedia: 'https://static.wixstatic.com/media/1d7134_3c2667b63dcf45f7a3a67c82375c62b8~mv2.webp'
    },
    {
        name: "Air Products",
        id: "b92a2658-fe8a-e2be-54fa-d883b4633fd3",
        mainMedia: 'https://static.wixstatic.com/media/9be79e_a415c2bc325442d5ad6de0a2f519cff6~mv2.webp'
    },
    {
        name: "Refrigerators",
        id: "0a07989b-f00c-88bd-7245-b45b40c8fb73",
        mainMedia: 'https://static.wixstatic.com/media/1d7134_ad69279bc3854fd28169969dca62e58a~mv2.png'
    },
    {
        name: "Dishwashers",
        id: "12033eb5-edcd-74fc-f576-cdf658ce1d89",
        mainMedia: 'https://static.wixstatic.com/media/1d7134_c03035b3949d4140a631560d5d1534ce~mv2.webp'
    },
    {
        name: "Microwave Ovens",
        id: "96c4d2bf-ad7e-f29f-e8de-bea98dbb12aa",
        mainMedia: 'https://static.wixstatic.com/media/1d7134_74e89ad716934cef9f34165d08855e79~mv2.png'
    },
    {
        name: "Cooking Ranges",
        id: "2cbd4c02-de97-643f-da48-1a9a4eeafae8",
        mainMedia: 'https://static.wixstatic.com/media/1d7134_a7e84e76149940188ff909ab8d85f65e~mv2.webp'
    },
    {
        name: "Kitchen Packages",
        id: "966393e0-1d9c-2f3c-0012-903e3497e0d0",
        mainMedia: 'https://static.wixstatic.com/media/1d7134_a7e84e76149940188ff909ab8d85f65e~mv2.webp'
    },
];

export const CATEGORIES = {
    SUPPORT_ONLY_PRODUCTS: '4f15c281-e9be-e0b3-517f-5492e31f768c',
    FIRMWARE_ONLY_PRODUCTS: '0ca5b322-9480-4b20-f21f-461e5b07224b',
}

export const STORES_COLLECTION_IDS = {
    WARRANTY: '777c5436-ffb0-2061-46a8-4921de4a3b84',
}


export const COLLECTIONS = {
    SPECS: "Specs",
    STORE_PRODUCTS: 'Stores/Products',
    TASKS: "Tasks",
    COMPILED_PRODUCTS: 'CompiledProducts',
    CMS_PRODUCTS: 'Products1',
    CMS_PRODUCTS_KEY_FEATURES: 'ProductsKeyFeatures',
    DEBUG_PRODUCTSFEEDBACK: 'debugProductsFeebdack',
    AWARDS_ACCOLADES: 'AwardsAccolades',
    BATCHES: 'Batches',
    BATCH_GROUPS: 'batchGroups',
    FIRMWARE_TESTS: 'firmwareTests',
    FIRMWARE_README_FILE: 'FirmwareGlobalReadme'
}

export const HBSPT_FORMS = {
    GEN_INQ: "0bcfaade-f431-4abf-97b4-5e047a484163",
    PARTS_SERVICE: "044cb92d-6889-43ad-8338-5fcf364ddcb3",
    PRODUCT_REGISTRATION: "b1ac2ab9-4518-4c6b-bfc7-2423f95656a2",
    TV_INSTALLATION: "52a2a1dd-d566-4d78-b412-2a8791eab9c2",
}

export const GCPProjectId="wix-managed-601e3933";